import { FC, useState } from 'react';
import { ImageComponent, ImageType } from '..';
import { useResizeHook } from '../../../utils';
import type { BannerComponentPropsTypes } from './types/propsTypes';
import styles from './BannerComponent.module.scss';
import { bannerDynamicHeight } from './BannerComponentUtil';

const BannerComponent: FC<BannerComponentPropsTypes> = ({
  bannerTitle,
  link,
  alt,
  cssCode,
}: BannerComponentPropsTypes): JSX.Element => {
  const getBannerTitleHeight = () =>
    bannerTitle && `${document.querySelector(`[class="${styles['banner-title']}"]`)?.clientHeight}px`;
  const [dynamicHeightClass, setDynamicHeightClass] = useState<string>('');

  useResizeHook(() => {
    const dynamicClass = bannerDynamicHeight(getBannerTitleHeight());
    setDynamicHeightClass(styles[dynamicClass]);
  });

  return (
    <div className={`${styles['cpw-banner-container']} ${dynamicHeightClass}`}>
      <ImageComponent link={link} alt={alt} imagetype={ImageType.PLP_LISTING_CONTAINER} />
      {bannerTitle && (
        <div
          className={styles['banner-title-container']}
          style={{ background: `linear-gradient(to right, ${cssCode}, #ffffff00)` }}
        >
          <h1 className={styles['banner-title']} id="bannerTitle">
            {bannerTitle}
          </h1>
        </div>
      )}
    </div>
  );
};

export default BannerComponent;
export type { BannerComponentPropsTypes };
